import { HeroCard } from "/react4xp/components/cards/HeroCard";

export default (props) => <HeroCard {...props} />;
